import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ChromeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M6.5 4.1a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8m0 0h5.502M1.67 2.936 4.424 7.7m1.404 4.764L8.576 7.7M12.5 6.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0" /></svg>
  );
}

export default ChromeIcon;
